import { Card, Button } from 'elmo-elements';
import loginBackround from './assets/login-bg.svg';
import desctopLoginBackground from './assets/login-svg-smaller.svg';
import tabletBackground from './assets/login-tablet.svg';
import googleIcon from './assets/icon-google.svg';
import styled from 'styled-components';

export const LoginLayout = styled.div`
  background-image: url(${loginBackround});
  background-position: center center;
  background-size: cover;
  width: 100%;
  overflow: hidden;
  display: flex;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.14);
  height: 100vh;

  @media screen and (min-device-width: 1200px) and (max-device-width: 1600px) and (-webkit-min-device-pixel-ratio: 2) {
    background-image: url(${desctopLoginBackground});
  }

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    background-image: url(${tabletBackground});
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    background-image: none;
    background-color: #fff;
  }
`;

export const CardWithBackground = styled(Card)`
  padding: 70px 40px 20px !important;
  margin-bottom: auto !important;
  // This overrides the margin-bottom style applied to the Card component,
  // because we are using it in a different way here to what it was designed for
  margin: auto;
  text-align: center;
  min-width: 470px;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    min-width: 260px;
    padding: 70px 30px 20px !important;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    min-width: 200px;
    max-width: 90%;
    padding: 50px 20px 20px !important;
    box-shadow: none !important;
  }
`;

export const ButtonWrapper = styled.div`
  text-align: center;
  margin: 30px 0 0 0;

  & button {
    cursor: pointer;
    color: #212121 !important;
  }
`;

export const MainHeading = styled.h2`
  text-align: center;
`;

export const SubHeading = styled.h3`
  text-align: center;
  font-size: 28px;
  font-weight: 600;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    font-size: 20px;
  }
`;

export const LoginButton = styled(Button)`
  width: 100%;
  border: 2px solid #19579f !important;
  background: url(${googleIcon}) #fff no-repeat 20px center !important;
  margin: 30px 0;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    background-position: 10px center !important;
    margin: 20px 0;
    font-size: 12px !important;
  }
`;

export const LoginParagraph = styled.h5`
  font-size: 19px !important;
  font-weight: normal;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    font-size: 14px !important;
  }
`;

export const Logo = styled.img`
  width: 220px;
  margin: auto;
  margin-bottom: 70px;

  @media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
    width: 160px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) {
    width: 150px;
  }
`;
